module.exports = __webpack_public_path__ + "static/media/theater-popcorn@2x.58e55844.png";